module.exports = __webpack_public_path__ + "img/resource-tech-image-72.bb6f40e8.jpg";